/* ============================================================
   IMUSCLES — HealthKart-Style Blog JS
   File: assets/article-hk.js
   Upload to: Shopify Admin > Themes > Edit Code > Assets
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initTOC();
    initSearch();
    initShareButtons();
    initReadingProgress();
  });

  /* ══════════════════════════════════════════════════════════
     1. TABLE OF CONTENTS GENERATOR
     ══════════════════════════════════════════════════════════ */
  function initTOC() {
    var content = document.querySelector('.art-hk-content');
    var tocNav  = document.getElementById('art-hk-toc-nav');
    var tocWrap = document.getElementById('art-hk-toc');

    if (!content || !tocNav || !tocWrap) return;

    var headings = content.querySelectorAll('h2, h3');

    if (headings.length < 2) {
      tocWrap.style.display = 'none';
      return;
    }

    var h2Counter = 0;
    var h3Counter = 0;

    headings.forEach(function (heading) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent) + '-' + Math.random().toString(36).substr(2, 4);
      }

      var link = document.createElement('a');
      link.href = '#' + heading.id;

      if (heading.tagName === 'H2') {
        h2Counter++;
        h3Counter = 0;
        link.textContent = h2Counter + '. ' + heading.textContent.trim();
        link.className = 'toc-h2';
      } else {
        h3Counter++;
        link.textContent = h2Counter + '.' + h3Counter + '. ' + heading.textContent.trim();
        link.className = 'toc-h3';
      }

      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(heading.id);
        if (target) {
          var offset = 80;
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });

      tocNav.appendChild(link);
    });

    highlightActiveTOCLink(headings);
  }

  function highlightActiveTOCLink(headings) {
    var tocLinks = document.querySelectorAll('#art-hk-toc-nav a');
    if (!tocLinks.length) return;

    window.addEventListener('scroll', function () {
      var scrollPos = window.pageYOffset + 100;
      var current = '';

      headings.forEach(function (h) {
        if (h.offsetTop <= scrollPos) {
          current = h.id;
        }
      });

      tocLinks.forEach(function (link) {
        link.style.color = '';
        link.style.fontWeight = '';
        if (link.getAttribute('href') === '#' + current) {
          link.style.color = '#F88B35';
          link.style.fontWeight = '700';
        }
      });
    }, { passive: true });
  }

  window.artHkToggleTOC = function () {
    var nav = document.getElementById('art-hk-toc-nav');
    var btn = document.getElementById('art-hk-toc-btn');
    if (!nav || !btn) return;

    if (nav.style.display === 'none') {
      nav.style.display = 'block';
      btn.textContent = '−';
    } else {
      nav.style.display = 'none';
      btn.textContent = '+';
    }
  };


  /* ══════════════════════════════════════════════════════════
     2. FAQ ACCORDION TOGGLE
     ══════════════════════════════════════════════════════════ */
  window.artHkToggleFAQ = function (btn) {
    var item   = btn.parentElement;
    var ans    = item.querySelector('.art-hk-faq-a');
    var icon   = btn.querySelector('.art-hk-faq-icon');
    var isOpen = ans.classList.contains('open');

    document.querySelectorAll('.art-hk-faq-a.open').forEach(function (openAns) {
      openAns.classList.remove('open');
      var openBtn  = openAns.previousElementSibling;
      var openIcon = openBtn && openBtn.querySelector('.art-hk-faq-icon');
      if (openBtn)  openBtn.setAttribute('aria-expanded', 'false');
      if (openIcon) openIcon.textContent = '+';
    });

    if (!isOpen) {
      ans.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      if (icon) icon.textContent = '−';
    }
  };


  /* ══════════════════════════════════════════════════════════
     3. SEARCH BAR
     ══════════════════════════════════════════════════════════ */
  function initSearch() {
    var form  = document.getElementById('art-hk-search-form');
    var input = document.getElementById('art-hk-search-input');

    if (!form || !input) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var term = input.value.trim();
      if (term.length > 0) {
        window.location.href = '/search?q=' + encodeURIComponent(term) + '&type=article';
      }
    });
  }


  /* ══════════════════════════════════════════════════════════
     4. SHARE BUTTONS
     ══════════════════════════════════════════════════════════ */
  function initShareButtons() {
    var url   = encodeURIComponent(window.location.href);
    var title = encodeURIComponent(document.title);

    var fbBtn = document.getElementById('art-hk-share-fb');
    if (fbBtn) {
      fbBtn.href = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
      fbBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openPopup(this.href, 'facebook-share', 600, 400);
      });
    }

    var twBtn = document.getElementById('art-hk-share-tw');
    if (twBtn) {
      twBtn.href = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title;
      twBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openPopup(this.href, 'twitter-share', 600, 400);
      });
    }

    var waBtn = document.getElementById('art-hk-share-wa');
    if (waBtn) {
      waBtn.href = 'https://api.whatsapp.com/send?text=' + title + '%20' + url;
    }
  }

  function openPopup(url, name, w, h) {
    var left = (window.innerWidth  / 2) - (w / 2);
    var top  = (window.innerHeight / 2) - (h / 2);
    window.open(url, name, 'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top);
  }


  /* ══════════════════════════════════════════════════════════
     5. READING PROGRESS BAR
     ══════════════════════════════════════════════════════════ */
  function initReadingProgress() {
    var bar = document.getElementById('art-hk-progress');
    if (!bar) return;

    var content = document.querySelector('.art-hk-content');
    if (!content) return;

    window.addEventListener('scroll', function () {
      var contentTop    = content.offsetTop;
      var contentHeight = content.offsetHeight;
      var scrolled      = window.pageYOffset - contentTop;
      var percent       = Math.min(100, Math.max(0, (scrolled / contentHeight) * 100));
      bar.style.width   = percent + '%';
    }, { passive: true });
  }


  /* ══════════════════════════════════════════════════════════
     6. IMAGE LIGHTBOX
     ══════════════════════════════════════════════════════════
     Called by onclick on .art-hk-featured-img wrapper div.
     Opens the #art-hk-lightbox overlay with a high-res image.
     Close: click anywhere on overlay, click ✕, or press Escape.
     ────────────────────────────────────────────────────────── */
  window.artHkOpenLightbox = function (src, alt) {
    var lb    = document.getElementById('art-hk-lightbox');
    var lbImg = document.getElementById('art-hk-lightbox-img');
    if (!lb || !lbImg) return;

    lbImg.src = src;
    lbImg.alt = alt || '';
    lb.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    /* Fade in */
    lb.style.opacity = '0';
    requestAnimationFrame(function () {
      lb.style.transition = 'opacity 0.2s ease';
      lb.style.opacity    = '1';
    });
  };

  window.artHkCloseLightbox = function () {
    var lb = document.getElementById('art-hk-lightbox');
    if (!lb || lb.style.display === 'none') return;

    lb.style.opacity = '0';
    setTimeout(function () {
      lb.style.display     = 'none';
      lb.style.opacity     = '';
      lb.style.transition  = '';
      document.body.style.overflow = '';
    }, 200);
  };

  /* Close on Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.artHkCloseLightbox();
  });


  /* ══════════════════════════════════════════════════════════
     UTILITY: SLUGIFY
     ══════════════════════════════════════════════════════════ */
  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[\s\W-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

})();
